import styled from '@emotion/styled/macro'
import { appNavigationCollapseWidth } from 'components/constants'
import { themeColor } from 'mixins'
import { Nav } from 'office-ui-fabric-react'
import { appNavigationNavHeight } from '../constants'

const height = appNavigationNavHeight

export const StyledNav = styled(Nav)`
  .ms-Nav-compositeLink {
    background: transparent;
    color: ${themeColor('neutralLighter')};
  }
  .ms-Nav-compositeLink:hover .ms-Nav-link .ms-Button-icon {
    background: ${themeColor('neutralLighter')};
    color: ${themeColor('neutralPrimary')};
  }

  .ms-Nav-compositeLink:hover .ms-Nav-linkText {
    color: ${themeColor('neutralPrimary')}; //CuttO
  }

  .ms-Nav-chevronButton {
    background: transparent;
    color: ${themeColor('neutralLighter')};
  }

  .ms-Nav-link {
    border-left-width: 0;
    color: ${themeColor('neutralLighter')};
  }

  .ms-Button--action,
  .ms-Button--command {
    height: ${height}px;
    color: ${themeColor('neutralLighter')};
  }
`

export const AppNavigationNav = styled(StyledNav)`
  .ms-Nav-link .ms-Button-icon {
    padding: 0 0px;
    color: ${themeColor('neutralLighter')};
  }
  .ms-Nav-compositeLink.is-selected {
    .ms-Nav-link {
      border-left-width: 0px;
      color: ${themeColor('neutralPrimary')};
    }
    .ms-Nav-linkText {
      color: ${themeColor('neutralPrimary')};
    }
    .ms-Button-icon {
      color: ${themeColor('neutralPrimary')};
    }
  }
`

export const AppNavigationBottomNav = styled(StyledNav)`
  background: ${themeColor('neutralPrimary')};
  border-top: 1px solid ${themeColor('neutralLighter')};

  .ms-Nav-navItems {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .ms-Nav-navItem {
    flex: 1 0 ${appNavigationCollapseWidth}px;
    border-right: 1px solid ${themeColor('neutralLight')};
  }
  .ms-Nav-link {
    padding: 0;
    > div {
      justify-content: center;
    }
  }
  .ms-Nav-linkText {
    display: none;
  }

  .ms-Button-icon {
    color: ${themeColor('neutralLighter')};
  }

  .ms-Nav-compositeLink {
    &:hover .ms-Nav-link {
      background: ${themeColor('neutralLighter')}!important;
    }
  }
  .ms-Nav-compositeLink.is-selected {
    .ms-Nav-link {
      background: ${themeColor('neutralLighter')};
    }
    .ms-Button-icon {
      color: ${themeColor('neutralPrimary')};
    }
    .ms-Nav-link::after {
      border-left-width: 0;
    }
  }
`
